const eGameMode = {
  EGM_REGULAR: 'regular',
  EGM_BONUS: 'bonus',
};

export default eGameMode;
